import gql from 'graphql-tag'

export default gql`
query SmartListingQuery($role: Role!) {
  administrators(role: $role) {
    rid
    name
    link
    genieSettings {
      outOfOffice
      level
      preferredPartners
      preferredLenders
    }
    portfolio(role: $role) {
      value
      numActiveLoans
      leftUntilCap
      percentageOfCap
      averageSmartRate
      loansLast30
      loansLast4
      loansAssignedToday
      shortTermThrottled
    }
  }
}
`
